import React from 'react';
import SchemeManagementSectionContainer from '../../SchemeManagementSectionContainer/SchemeManagementSectionContainer';
import { Col, Form, Row } from 'react-bootstrap';
import { getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { CalculationClassField } from '../../CalculationClassField/CalculationClassField';

const CalculationServiceForm = ({ handleSubmit, isViewOnly }) => {
  return (
    <SchemeManagementSectionContainer
      title={''}
      subTitle={'Winter Sports Decline Handling'}
      isViewOnly={isViewOnly}
    >
      <Form horizontal onSubmit={handleSubmit}>
        <Row className="section-item">
          <Col sm={12}>
            <CalculationClassField
              label="Winter Sports decline on each traveller"
              name={'data.attributes.metadata.calculation_class'}
              isViewOnly={isViewOnly}
            />
          </Col>
        </Row>
      </Form>
    </SchemeManagementSectionContainer>
  );
};
export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(props.formName)(state),
      destroyOnUnmount: false,
      enableReinitialize: true,
      form: props.formName,
    };
  }),
  reduxForm({}),
)(CalculationServiceForm);
